import { lazy } from 'react';
import { PurchaseModalLoading } from '@/components/purchase-sheet';
import { addonPurchaseRequest } from './addon-purchase-request';
import { LazyPanelBoundary } from './lazy-panel-boundary';

const LazyAddonPurchasePanel = lazy(() =>
  import('./addon-purchase-panel').then((module) => ({ default: module.AddonPurchasePanel })),
);

type AddonPurchaseHostProps = {
  onLearnMorePricing?: () => void;
};

export function AddonPurchaseHost({ onLearnMorePricing }: AddonPurchaseHostProps) {
  const request = addonPurchaseRequest.useRequestState();
  const isOpen = addonPurchaseRequest.useIsOpen();
  addonPurchaseRequest.useHost();

  return (
    <LazyPanelBoundary
      resetKey={request?.key}
      onLoadError={() => addonPurchaseRequest.dismiss()}
      fallback={
        <PurchaseModalLoading
          isOpen={isOpen}
          onClose={() => addonPurchaseRequest.dismiss()}
          onCloseComplete={addonPurchaseRequest.clear}
        />
      }
    >
      {request == null ? null : (
        <LazyAddonPurchasePanel
          key={request.key}
          isOpen={isOpen}
          onCloseComplete={addonPurchaseRequest.clear}
          data={request.data}
          onConfirm={addonPurchaseRequest.confirm}
          onClose={() => addonPurchaseRequest.dismiss()}
          onBusyChange={addonPurchaseRequest.setBusy}
          onLearnMorePricing={
            onLearnMorePricing == null
              ? undefined
              : () => {
                  addonPurchaseRequest.dismiss();
                  onLearnMorePricing();
                }
          }
        />
      )}
    </LazyPanelBoundary>
  );
}
